var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_19974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.94 1.55872C22.2602 0.879917 21.3387 0.498657 20.378 0.498657C19.4173 0.498657 18.4958 0.879917 17.816 1.55872L0 19.3747V24.4987H5.124L22.94 6.68272C23.6186 6.00274 23.9997 5.08135 23.9997 4.12072C23.9997 3.16009 23.6186 2.2387 22.94 1.55872ZM4.3 22.4987H2V20.1987L15.31 6.89872L17.61 9.19872L4.3 22.4987ZM21.526 5.26872L19.019 7.77572L16.724 5.47572L19.23 2.97272C19.535 2.66772 19.9487 2.49637 20.38 2.49637C20.8113 2.49637 21.225 2.66772 21.53 2.97272C21.835 3.27772 22.0063 3.69139 22.0063 4.12272C22.0063 4.55405 21.835 4.96772 21.53 5.27272L21.526 5.26872Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_19974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.2eed907be7dafd894e08219834a554de.svg";
export { ForwardRef as ReactComponent };